import { toast } from "react-toastify";
import {
  STORE_ADD_SUCCESS,
  STORE_ADD_REQUEST,
  STORE_ADD_FAIL,
  STORE_ADD_RESET,
  //
  STORE_LIST_SUCCESS,
  STORE_LIST_REQUEST,
  STORE_LIST_FAIL,
  //
  STORE_DETAIL_SUCCESS,
  STORE_DETAIL_REQUEST,
  STORE_DETAIL_FAIL,
  //
  STORE_DELETE_SUCCESS,
  STORE_DELETE_REQUEST,
  STORE_DELETE_FAIL,
  //
  STORE_UPDATE_SUCCESS,
  STORE_UPDATE_REQUEST,
  STORE_UPDATE_FAIL,
  //
  STORE_TIME_SUCCESS,
  STORE_TIME_REQUEST,
  STORE_TIME_FAIL,
  //
  STORE_TIME_UPDATE_SUCCESS,
  STORE_TIME_UPDATE_REQUEST,
  STORE_TIME_UPDATE_FAIL,

  //
} from "../constants/storeConstants";

export const updateStoreTimesReducer = (state = {}, action) => {
  switch (action.type) {
    case STORE_TIME_UPDATE_REQUEST:
      return { loadingStoreUpdateTime: true };
    case STORE_TIME_UPDATE_SUCCESS:
      toast.success("This Store Times has been successfully updated");
      return {
        loadingStoreUpdateTime: false,
        successStoreUpdateTime: true,
      };
    case STORE_TIME_UPDATE_FAIL:
      return {
        loadingStoreUpdateTime: false,
        errorStoreUpdateTime: action.payload,
        successStoreUpdateTime: false,
      };
    default:
      return state;
  }
};

export const getListTimesStoreReducer = (
  state = { storeTimes: [] },
  action
) => {
  switch (action.type) {
    case STORE_TIME_REQUEST:
      return { loadingTimesStore: true, storeTimes: [] };
    case STORE_TIME_SUCCESS:
      return {
        loadingTimesStore: false,
        storeTimes: action.payload.timings,
        pages: action.payload.pages,
        page: action.payload.page
      };
    case STORE_TIME_FAIL:
      return {
        loadingTimesStore: false,
        errorTimesStore: action.payload,
      };
    default:
      return state;
  }
};

export const deleteStoreReducer = (state = {}, action) => {
  switch (action.type) {
    case STORE_DELETE_REQUEST:
      return { loadingStoreDelete: true };
    case STORE_DELETE_SUCCESS:
      toast.success("This Store has been successfully deleted.");
      return {
        loadingStoreDelete: false,
        successStoreDelete: true,
      };
    case STORE_DELETE_FAIL:
      return {
        loadingStoreDelete: false,
        errorStoreDelete: action.payload,
        successStoreDelete: false,
      };
    default:
      return state;
  }
};

export const updateStoreReducer = (state = {}, action) => {
  switch (action.type) {
    case STORE_UPDATE_REQUEST:
      return { loadingStoreUpdate: true };
    case STORE_UPDATE_SUCCESS:
      toast.success("This Store has been successfully updated");
      return {
        loadingStoreUpdate: false,
        successStoreUpdate: true,
      };
    case STORE_UPDATE_FAIL:
      return {
        loadingStoreUpdate: false,
        errorStoreUpdate: action.payload,
        successStoreUpdate: false,
      };
    default:
      return state;
  }
};

export const detailStoreReducer = (state = { storeInfo: {} }, action) => {
  switch (action.type) {
    case STORE_DETAIL_REQUEST:
      return { loadingStoreInfo: true };
    case STORE_DETAIL_SUCCESS:
      return {
        loadingStoreInfo: false,
        successStoreInfo: true,
        storeInfo: action.payload.store,
      };
    case STORE_DETAIL_FAIL:
      return {
        loadingStoreInfo: false,
        successStoreInfo: false,
        errorStoreInfo: action.payload,
      };
    default:
      return state;
  }
};

export const createNewStoreReducer = (state = {}, action) => {
  switch (action.type) {
    case STORE_ADD_REQUEST:
      return { loadingStoreAdd: true, successStoreAdd: false };
    case STORE_ADD_SUCCESS:
      toast.success("This Store has been added successfully");
      return {
        loadingStoreAdd: false,
        successStoreAdd: true,
      };
    case STORE_ADD_FAIL:
      toast.error(action.payload);
      return {
        loadingStoreAdd: false,
        successStoreAdd: false,
        errorStoreAdd: action.payload,
      };
    case STORE_ADD_RESET:
      return {};
    default:
      return state;
  }
};

export const getListStoresReducer = (state = { stores: [] }, action) => {
  switch (action.type) {
    case STORE_LIST_REQUEST:
      return { loadingListStores: true, stores: [] };
    case STORE_LIST_SUCCESS:
      return {
        loadingListStores: false,
        stores: action.payload.stores,
        pages: action.payload.pages,
        page: action.payload.page
      };
    case STORE_LIST_FAIL:
      return {
        loadingListStores: false,
        errorListStores: action.payload,
      };
    default:
      return state;
  }
};
